/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuctionManagementExportLivecarpItemResponse } from './AuctionManagementExportLivecarpItemResponse';

export type AuctionManagementExportLivecarpItemResponseApiRespoonse = {
    data?: AuctionManagementExportLivecarpItemResponse;
    status?: AuctionManagementExportLivecarpItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AuctionManagementExportLivecarpItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

